<template>
  <div class="container no-margin">
    <number-input
      :label="label"
      :placeholder="hint"
      subhint="Está conformado por 11 dígitos, incluídos los ceros."
      :value="value"
      name="nroTramiteDoc"
      :required="required"
      :maxlength="maxlength"
      @click="$emit('click')"
      @onFocus="$emit('onFocus')"
      @input="onInput"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import NumberInput from "@/components/core/NumberInput";
export default {
  name: "DniTramiteInput",
  components: { NumberInput },
  props: [
    "placeholder",
    "label",
    "value",
    "name",
    "hint",
    "required",
    "maxlength",
    "quantumObfuscate"
  ],
  methods: {
    onInput(value) {
      this.$emit("input", value);
    }
  }
};
</script>
